/**
 * Created by adalto on 11/13/14.
 * Render content form to transfer stops.
 */


Greenmile.Route = Greenmile.Route || {};
Greenmile.Route.TransferStops = Greenmile.Route.TransferStops || {};

Greenmile.Route.TransferStops.PopupContent = function () {

    this.rootEl = document.createElement('div');
    this.form = null;

    var renderContainerToListStops = function (listOrderedId, listOrderedClassName) {

        var baseEl = document.createDocumentFragment();
        var listStopsEl = document.createElement('div');
        var listOrdered = document.createElement('ol');
        var loading = document.createElement("img");

        loading.src = require("static/images/general/loading_blue.svg");
        loading.className = "loadingTransferStops";

        listStopsEl.className = 'listStops';

        listOrdered.id = listOrderedId;
        listOrdered.className = listOrderedClassName;

        listStopsEl.appendChild(loading);
        listStopsEl.appendChild(listOrdered);

        baseEl.appendChild(listStopsEl);

        return baseEl;

    };

    var showErrors = function (errors) {

        try {

            var monetMessage = new Monet.Form.Messages.InlineMessage();
            var scope = "#RouteSummary .popupFormContainer #filterRoute";

            monetMessage.setInfoType("error");
            monetMessage.setScope(scope);
            monetMessage.setMessage(errors);
            monetMessage.triggerMessage();

        } catch (e) {

            var error = new Monet.Exception.ReturnError(this,
                "No show errors form.");
            error.console();

        }
    };

    var eventBtnSearch = function (scope) {

        return function () {

            var result,
                request,
                selector = "#RouteSummary .popupFormContainer #filterRoute .alert";

            result = scope.form.validate();

            if (result.status) {

                var bestInsertionButton = document.querySelector('#bestInsertion.stopConnect.stopSourceConnect');
                bestInsertionButton.style.display = 'block';

                var selectorToList = '#stopsRouteFiltered';
                var divError = document.querySelector(selector);
                if (divError) {
                  divError.parentElement.removeChild(divError);
                }

                const filter = scope.form.getValues();

                Monet.Session.TransferStops = Monet.Session.TransferStops || {};
                Monet.Session.TransferStops.stopsRouteFiltered = { filter };
                request = new Greenmile.Route.TransferStops.Requests();
                request.getStopsAndAddToList(filter, selectorToList);
            } else {
                showErrors(result);
            }
        };

    }(this);

    var renderSearchButton = function () {

        var buttonSearchEl = new Monet.UI.Fields.Button();

        buttonSearchEl.value = Monet.I18n.getResourcesByKey('Route.TransferStops.button.search');
        buttonSearchEl.render();
        buttonSearchEl.setId('transferStopBtnSearchRoute');
        buttonSearchEl.addEventClickListener(eventBtnSearch);

        return buttonSearchEl.rootEl;

    };

    var renderFieldFilters = function (scope) {

        return function () {

            var fieldsList = {
                sections: [{
                    key: 'transferStops',
                    sectionFields: [
                        {
                            field: {
                                id: 'organization',
                                name: 'organization',
                                label: "Route.TransferStops.label.Organization",
                                lookupEntity: 'Organization',
                                lookupEntityColumn: 'description',
                                mandatory: 'true',
                                type: 'LOOKUP'
                            },
                            sectionColumn: 1
                        }, {
                            field: {
                                id: 'route',
                                name: 'key',
                                label: "Route.TransferStops.label.routeKey",
                                mandatory: 'true',
                                type: 'TEXT'
                            },
                            sectionColumn: 1
                        }, {
                            field: {
                                id: 'routeDate',
                                name: 'date',
                                label: "Route.TransferStops.label.routeDate",
                                mandatory: 'true',
                                type: 'DATE'
                            },
                            sectionColumn: 1
                        }]
                }]
            };

            scope.form = new Monet.Builder.Form.Base(fieldsList, 'TransferStop');
            var formRendered = scope.form.renderBaseForm().allContent;
            formRendered.setAttribute('id', 'filterRoute');
            formRendered.getElementsByClassName('MonetUIFormSectionColumn')[0].appendChild(renderSearchButton());

            return formRendered;

        };

    }(this);

    var renderContainerPrincipalRoute = function () {

        var baseEl = document.createDocumentFragment();
        var titleRouteEl = document.createElement('div');

        titleRouteEl.className = 'transferStop_titleRoutePrincipal';

        baseEl.appendChild(titleRouteEl);
        baseEl.appendChild(renderContainerToListStops('stopsRouteSelected', 'stopSourceConnect'));

        return baseEl;

    };

    var renderFormFilter = () => {
      const fragment = document.createDocumentFragment();
      const rowSearchedRouteEl = document.createElement('div');
      const titleSearchedRouteEl = document.createElement('div');

      titleSearchedRouteEl.className = 'transferStop_titleRouteSearched';
      rowSearchedRouteEl.appendChild(titleSearchedRouteEl);
      fragment.appendChild(renderFieldFilters());
      fragment.appendChild(rowSearchedRouteEl);

      return fragment;
    };

    var renderSearchedRoute = function () {

        return renderContainerToListStops('stopsRouteFiltered', 'stopSourceConnect');

    };

    var renderBestInsertion = function () {

        var baseEl = document.createElement('div');
        var orderedList = document.createElement('ol');

        orderedList.className = 'stopConnect stopSourceConnect';
        orderedList.id = 'bestInsertion';

        orderedList.innerHTML = Monet.I18n.getResourcesByKey('Route.TransferStops.label.bestInsertion');
        orderedList.style.display = 'none';

        baseEl.appendChild(orderedList);

        return baseEl;

    };


    this.render = function () {

        if (App.Forms.TransferStopLookupOrganization) {
            delete App.Forms.TransferStopLookupOrganization;
        }

        const fragments = document.createDocumentFragment();

        fragments.appendChild(renderContainerPrincipalRoute());
        fragments.appendChild(renderFormFilter());
        fragments.appendChild(renderSearchedRoute());
        fragments.appendChild(renderBestInsertion());

        this.rootEl.appendChild(fragments);
        this.rootEl.className = 'transferStop_container';

        return this.rootEl;

    };

};
